import { useAppSelector } from "app/redux/hooks";
import { Parametro, ParametroPorItem } from "app/types/Parametro";
import { obterPermissao } from "app/use-cases/obterPermissao";
import { definirDespesasInclusas } from "app/use-cases/orcamento/definirDespesasInclusas";
import { obterParametros, obterParametrosPorOidItem } from "app/use-cases/parametro/obterParametros";
import globalMU from "globalMU";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Totalizador } from "./Totalizador";
import { definirValorDescontoAcumulado } from "../../use-cases/orcamento/definirValorDescontoAcumulado";
import { definirPercentualDesconto } from "../../use-cases/orcamento/definirPercentualDesconto";
import { definirValorDesconto } from "../../use-cases/orcamento/definirValorDesconto";
import { definirPercentualDescontoAcumulado } from "app/use-cases/orcamento/definirPercentualDescontoAcumulado";
import { definirPercentualSeguroEntrega } from "app/use-cases/orcamento/definirPercentualSeguroEntrega";
import { definirValorSeguroEntrega } from "app/use-cases/orcamento/definirValorSeguroEntrega";
import { definirPercentualFrete, definirValorFrete } from "app/use-cases/orcamento/definirValorFrete";
import { definirValorAcrescimoFinanceiro } from "app/use-cases/orcamento/definirValorAcrescimoFinanceiro";
import { definirPercentualDescontoMercadoriasImportadas } from "app/use-cases/orcamento/definirPercentualDescontoMercadoriasImportadas";
import { definirValorDescontoMercadoriasImportadas } from "app/use-cases/orcamento/definirValorDescontoMercadoriasImportadas";
import { definirPercentualDescontoMercadoriasNacionais } from "app/use-cases/orcamento/definirPercentualDescontoMercadoriasNacionais";
import { definirValorDescontoMercadoriasNacionais } from "app/use-cases/orcamento/definirValorDescontoMercadoriasNacionais";
import { v4 as uuidv4 } from 'uuid';
import * as totalizadorActions from 'app/redux/totalizadorSlice';
import store from "app/redux/store/store";
import { definirDescontoAcumuladoSobreMercadoriasImportadas } from "../../use-cases/orcamento/DefinirDescontoAcumuladoSobreMercadoriasImportadas";
import { definirValorDescontoAcumuladoSobreMercadoriasNacionais } from "../../use-cases/orcamento/definirValorDescontoAcumuladoSobreMercadoriasNacionais";
import { definirPercentualDescontoAcumuladoSobreMercadoriasNacionais } from "app/use-cases/orcamento/definirPercentualDescontoAcumuladoSobreMercadoriasNacionais";
import { definirPercentualDescontoAcumuladoSobreMercadoriasImportadas } from "app/use-cases/orcamento/definirPercentualDescontoAcumuladoSobreMercadoriasImportadas";
import microuniversoApi from "app/api/microuniversoApi";
import { CanalDeVenda, MotivoDesconto } from "app/types/orcamento/MotivoDesconto";
import { definirCodigoMotivoDesconto } from "app/use-cases/orcamento/DefinirCodigoMotivoDesconto";
import { Permissao } from "app/types/Permissao";
import { aplicarDescontoCashback } from "app/use-cases/orcamento/aplicarDescontoCashback";
import { definirValorServicosAgregados } from "app/use-cases/orcamento/definirValorServicosAgregados";
import { definirIdCanalDeVenda } from "app/use-cases/orcamento/definirIdCanalDeVenda";
import { desativacaoCamposDesconto } from "./camposDescontoEditaveis";


declare var window: any;

export const TotalizadorContainer = () => {
    const isMounted = useRef<boolean>(true)
    const [parametrosCarregados, setParametrosCarregados] = useState(false);
    const orcamento = useAppSelector(store => store.orcamento);
    const totalizadorRedux = useAppSelector(store => store.totalizador);

    const [parametros, setParametros] = useState<Parametro[]>([]);
    const [parametrosPorFilial, setParametrosPorFilial] = useState<ParametroPorItem[]>([]);
    const [permissoes, setPermissoes] = useState<Permissao[]>([]);
    const [motivosDesconto, setMotivosDesconto] = useState<MotivoDesconto[]>([]);
    const [listaCanalDeVenda, setListaCanalDeVenda] = useState<CanalDeVenda[]>([]);
    const [descontoZerado, setDescontoZerado] = useState(true);
    const [idUnico, setIdunico] = useState(uuidv4());

    useEffect(() => () => { isMounted.current = false }, [])

    const atualizarParametros = useCallback(async () => {
        if (!isMounted.current) return
        const parametrosGerais = await obterParametros({
            nomes: [
                "DESCONTO_ACUMULADO",
                "EXIBIR_PERCENTUAL_DESCONTO_ACUMULADO_ORCAMENTO",
                "ACRESCIMO_FINANCEIRO_VENDA_PRAZO",
                "APURA_IPI_VENDA",
                "EXIBIR_QUANTIDADE_PENDENTE_ORCAMENTO",
                "ACEITAR_PRODUTO_SEM_ESTOQUE",
                "APLICAR_PERCENTUAL_DESCONTO_SOBRE_PRECO_UNITARIO",
                "FRETE_PERCENTUAL_NO_ORCAMENTO",
                "TEXTO_PADRAO_SERVICOS_ADICIONAIS_ORCAMENTO"
            ]
        });

        const parametrosFilial = await obterParametrosPorOidItem({

            nomes: [
                "UTILIZA_SERVICO_AGREGADO_ORCAMENTO",
                "PERMITE_DESDOBRAR_PEDIDO_PRODUTO_IMPORTADO",
                "APURA_IPI_VENDA_FILIAL",
                "EXIGE_MOTIVO_DESCONTO_ORCAMENTO",
                "TRABALHA_COBRANCA_PIX_PRAZO", // 414608
                "UTILIZA_RELACIONAMENTO_FILIAL_VENDEDOR_FONTE_RECEITA", // 487678
                "TEXTO_PADRAO_SERVICOS_ADICIONAIS_ORCAMENTO"
            ],
            oidItem: orcamento.OidFilialOrcamento
        });

        setParametros(parametrosGerais);
        setParametrosPorFilial(parametrosFilial);
    }, [orcamento.OidFilialOrcamento]);

    const obterMotivosDesconto = useCallback(async () => {
        if (!isMounted.current) return
        
        setMotivosDesconto(await microuniversoApi.Orcamento.obterMotivosDesconto());
        
    }, []);

    const obterObterListaCanalDeVenda = useCallback(async () => { // 422642
        if (!isMounted.current) return
        setListaCanalDeVenda(await microuniversoApi.Orcamento.obterListaCanalDeVenda())
    }, [])

    const atualizarPermissoes = useCallback(async () => {
        if (!isMounted.current) return
        const permissoesAtualizadas = await Promise.all([
            obterPermissao({ funcionalidade: "TOTAIS_ORCAMENTO", acao: "EDITAR_SEGURO" }),
            obterPermissao({ funcionalidade: "TOTAIS_ORCAMENTO", acao: "EDITAR_DESPESAS_INCLUSAS" }),
            obterPermissao({ funcionalidade: "TOTAIS_ORCAMENTO", acao: "EXIBIR_CANAL_DE_VENDA" }), // 422642
            obterPermissao({ funcionalidade: "TOTAIS_ORCAMENTO", acao: "EDITAR_CANAL_DE_VENDA" }), // 422642
        ]);

        setPermissoes([
            { Acao: "EDITAR_SEGURO", Permitido: permissoesAtualizadas[0] },
            { Acao: "EDITAR_DESPESAS_INCLUSAS", Permitido: permissoesAtualizadas[1] },
            { Acao: "EXIBIR_CANAL_DE_VENDA", Permitido: permissoesAtualizadas[2] }, // 422642
            { Acao: "EDITAR_CANAL_DE_VENDA", Permitido: permissoesAtualizadas[3] }, // 422642
        ]);
        
    }, []);

    const valorParametro = useCallback(
        (nome: string) => parametros.find(p => p.Nome === nome)?.Valor,
        [parametros]
    );

    const valorParametroPorFilial = useCallback(
        (nome: string) => parametrosPorFilial.find(p => p.Nome === nome)?.Valor,
        [parametrosPorFilial]
    );

    const permissoesMap = useMemo(() => new Map(permissoes.map(p => [p.Acao, p.Permitido])), [permissoes]);

    const orcamentoSemItens = useMemo(() => (orcamento.ItensOrcamento ?? []).length === 0, [orcamento.ItensOrcamento]);

    // 482572 — as regras de desativação dos campos de DESCONTO saíram do JSX para um módulo puro
    // (camposDescontoEditaveis.ts), porque o snapshot de "orçamento em andamento" precisa das
    // MESMAS regras para decidir quais campos de desconto pode gravar/recuperar (ver
    // extrairSnapshotOrcamentoEmAndamento em app/redux/store/store.ts). Comportamento inalterado:
    // são as mesmas expressões que estavam inline nas props abaixo.
    const desativacaoDesconto = useMemo(() => desativacaoCamposDesconto({
        orcamento,
        edicoesDesabilitadas: totalizadorRedux.desabilitarEdicoes,
        valorParametro,
        valorParametroPorFilial,
    }), [orcamento, totalizadorRedux.desabilitarEdicoes, valorParametro, valorParametroPorFilial]);

    const onValorDescontoAcumuladoModificado = useCallback(async (valorDescontoAcumulado: number) => {
        if (!isMounted.current) return
        try {
            globalMU.blockUI({ tryPassiveLoading: false });
            await definirValorDescontoAcumulado({ valorDescontoAcumulado });
            store.dispatch(totalizadorActions.registrarAtualizacaoAction());
        } finally {
            globalMU.unblockUI();
        }
    }, []);


    const onPercentualSeguroModificado = useCallback(async (percentualSeguro: number) => {
        if (!isMounted.current) return
        try {
            globalMU.blockUI({tryPassiveLoading: false})
            await definirPercentualSeguroEntrega({percentualSeguroEntrega: percentualSeguro})
            store.dispatch(totalizadorActions.registrarAtualizacaoAction())
        } finally {
            globalMU.unblockUI()
        }
    }, [])

    const onValorFreteModificado = useCallback(async (valorFrete: number) => {
        if (!isMounted.current) return
        try {

            globalMU.blockUI({tryPassiveLoading: false})
            await definirValorFrete({valorFrete})
            store.dispatch(totalizadorActions.registrarAtualizacaoAction())
        } finally {
            globalMU.unblockUI()
        }
    }, [])

    const onPercentualFreteModificado = useCallback(async (percentualFrete: number) => {
        if (!isMounted.current) return
        try {
            globalMU.blockUI({tryPassiveLoading: false})
            await definirPercentualFrete({percentual: percentualFrete})
            store.dispatch(totalizadorActions.registrarAtualizacaoAction())
        } finally {
            globalMU.unblockUI()
        }
    }, [])

    const onValorSeguroModificado = useCallback(async (valorSeguro: number) => {
        if (!isMounted.current) return
        try {
            globalMU.blockUI({tryPassiveLoading: false})
            await definirValorSeguroEntrega({valorSeguroEntrega: valorSeguro})
            store.dispatch(totalizadorActions.registrarAtualizacaoAction())
        } finally {
            globalMU.unblockUI()
        }
    }, [])

    const onPercentualDescontoModificado = useCallback(async (percentualDesconto: number) => {
        if (!isMounted.current) return
        try {
            globalMU.blockUI({tryPassiveLoading: false})
            await definirPercentualDesconto({percentualDesconto})

            store.dispatch(totalizadorActions.registrarAtualizacaoAction())

        } finally {
            globalMU.unblockUI()
        }
    }, [])

    const onValorDescontoModificado = useCallback(async (valorDesconto: number) => {
        if (!isMounted.current) return
        try {
            globalMU.blockUI({tryPassiveLoading: false})
            await definirValorDesconto({valorDesconto})
            store.dispatch(totalizadorActions.registrarAtualizacaoAction())
        } finally {
            globalMU.unblockUI()
        }
    }, [])

    const onDespesasInclusasModificado = useCallback(async (valorDespesasInclusas: number) => {
        if (!isMounted.current) return
        try {
            globalMU.blockUI({tryPassiveLoading: false})

            await definirDespesasInclusas({
                valorDespesasInclusas
            })
            store.dispatch(totalizadorActions.registrarAtualizacaoAction())
        } finally {
            globalMU.unblockUI()
        }

    }, [])

    const onPercentualDescontoAcumuladoModificado = useCallback(async (percentualDescontoAcumulado:number) => {
        if (!isMounted.current) return
        try {
            globalMU.blockUI({tryPassiveLoading: false})

            await definirPercentualDescontoAcumulado({
                percentualDescontoAcumulado
            })
            store.dispatch(totalizadorActions.registrarAtualizacaoAction())
        } finally {
            globalMU.unblockUI()
        }
    }, [])

    const onValorAcrescimoFinanceiroModificado = useCallback(async (valorAcrescimoFinanceiro: number) => {
        if (!isMounted.current) return
        try {
            globalMU.blockUI({tryPassiveLoading: false})

            await definirValorAcrescimoFinanceiro({
                valorAcrescimoFinanceiro
            })

            store.dispatch(totalizadorActions.registrarAtualizacaoAction())
        } finally {
            globalMU.unblockUI()
        }
    }, [])

    const onPercentualDescontoMercadoriasImportadasModifcado = useCallback(async (percentualDesconto: number) => {
        if (!isMounted.current) return
        try {
            globalMU.blockUI({tryPassiveLoading: false})

            await definirPercentualDescontoMercadoriasImportadas({
                percentualDesconto
            })
            store.dispatch(totalizadorActions.registrarAtualizacaoAction())
        } finally {
            globalMU.unblockUI()

        }
    }, [])

    const onPercentualDescontoMercadoriasNacionaisModifcado = useCallback(async (percentualDesconto: number) => {
        if (!isMounted.current) return
        try {
            globalMU.blockUI({tryPassiveLoading: false})

            await definirPercentualDescontoMercadoriasNacionais({
                percentualDesconto
            })
            store.dispatch(totalizadorActions.registrarAtualizacaoAction())
        } finally {
            globalMU.unblockUI()

        }
    }, [])

    const onValorDescontoMercadoriasImportadasModifcado = useCallback(async (valorDesconto: number) => {
        if (!isMounted.current) return
        try {
            globalMU.blockUI({tryPassiveLoading: false})

            await definirValorDescontoMercadoriasImportadas({
                valorDesconto
            })
            store.dispatch(totalizadorActions.registrarAtualizacaoAction())
        } finally {
            globalMU.unblockUI()

        }
    }, [])

    const onValorDescontoAcumuladoNacionalModificado = useCallback(async (valorDesconto: number) => {
        if (!isMounted.current) return
        try {
            globalMU.blockUI({tryPassiveLoading: false})

            await definirValorDescontoAcumuladoSobreMercadoriasNacionais({
                valorDesconto
            })

            store.dispatch(totalizadorActions.registrarAtualizacaoAction())
        } finally {
            globalMU.unblockUI()

        }
    }, [])

    const onPercentualDescontoAcumuladoNacionalModificado = useCallback(async (percentualDesconto:number) => {
        if (!isMounted.current) return
        try {
            globalMU.blockUI({tryPassiveLoading: false})

            await definirPercentualDescontoAcumuladoSobreMercadoriasNacionais({
                percentualDesconto
            })

            store.dispatch(totalizadorActions.registrarAtualizacaoAction())
        } finally {
            globalMU.unblockUI()

        }
    }, [])

    const onPercentualDescontoAcumuladoImportadoModifcado = useCallback(async (percentualDesconto:number) => {
        if (!isMounted.current) return
        try {
            globalMU.blockUI({tryPassiveLoading: false})

            await definirPercentualDescontoAcumuladoSobreMercadoriasImportadas({
                percentualDesconto
            })

            store.dispatch(totalizadorActions.registrarAtualizacaoAction())
        } finally {
            globalMU.unblockUI()
        }
    }, [])

    const onValorDescontoMercadoriasNacionaisModificado = useCallback(async (valorDesconto: number) => {
        if (!isMounted.current) return
        try {
            globalMU.blockUI({tryPassiveLoading: false})

            await definirValorDescontoMercadoriasNacionais({
                valorDesconto
            })
            store.dispatch(totalizadorActions.registrarAtualizacaoAction())
        } finally {
            globalMU.unblockUI()

        }
    }, [])

    const onValorDescontoAcumuladoImportadoModificado = useCallback(async (valorDesconto: number) => {
        if (!isMounted.current) return
        try {
            globalMU.blockUI({tryPassiveLoading: false})
            await definirDescontoAcumuladoSobreMercadoriasImportadas({
                valorDesconto
            })
        } finally {
            globalMU.unblockUI()
        }
    }, [])

    const onAplicarDescontoCashback = useCallback(async (aplicarDesconto: boolean) => {
        try {
            globalMU.blockUI({tryPassiveLoading: false})
            await aplicarDescontoCashback(aplicarDesconto)
        } finally {
            globalMU.unblockUI()
        }
    }, [])

    const onMotivoDescontoSelecionado = useCallback(async (codigoMotivoDesconto: number) => {
        if (!isMounted.current) return
        try {
            globalMU.blockUI({tryPassiveLoading: false})
            await definirCodigoMotivoDesconto(codigoMotivoDesconto)
        } finally {
            globalMU.unblockUI()
        }
    }, [])

    const onCanalDeVendaSelecionado = useCallback(async (idCanalDeVenda: number) => { // 422642
        if (!isMounted.current) return
        try {
            
            globalMU.blockUI({tryPassiveLoading: false})
            await definirIdCanalDeVenda(idCanalDeVenda)
        } finally {
            globalMU.unblockUI()
        }
    }, [])

    const onValorServicosAgregadosModificado = useCallback(async (valorServicosAgregados: number) => {
        if (!isMounted.current) return
        try {
            globalMU.blockUI({tryPassiveLoading: false})
            await definirValorServicosAgregados({valorServicosAgregados: valorServicosAgregados})
            store.dispatch(totalizadorActions.registrarAtualizacaoAction())
        } finally {
            globalMU.unblockUI()
        }
    }, [])

    useEffect(() => {
        if (!isMounted.current) return
        const fetchData = async () => {
            
            await Promise.all([
                atualizarParametros(),
                atualizarPermissoes(),
                //obterMotivosDesconto()
            ]);
    
            if (orcamento.SomenteLeitura) {
                store.dispatch(totalizadorActions.desabilitarEdicoesAction(true));
            }
        };
    
        fetchData();
    }, [orcamento?.OidFilialOrcamento]);
    
    useEffect(() => {
        if (!isMounted.current) return
        setIdunico(uuidv4());
    }, [orcamento.UltimaAtualizacao]);
    
    const onDescontoZerado = () => {
        if (!isMounted.current) return
        setDescontoZerado(true); 
        orcamento.CodigoMotivoDesconto != undefined ? orcamento.CodigoMotivoDesconto != 0 ? onMotivoDescontoSelecionado(0) : null : null;
    }
    useEffect(() => {
        if (!isMounted.current) return
        orcamento.ValorDesconto > 0 || orcamento.DescontoAcumulado > 0 || orcamento.ItensOrcamento?.filter(i => i.ValorDesconto > 0).length > 0 ? 
        setDescontoZerado(false) : 
        onDescontoZerado()
    },[orcamento.ValorDesconto, orcamento.DescontoAcumulado, orcamento.ItensOrcamento])

    {/*
    useEffect(() => {
        if (!isMounted.current) return
        obterMotivosDesconto() 


    },[])
*/}

    useEffect(()=> {
        if (!isMounted.current) return
        if (parametrosPorFilial && parametrosPorFilial.length > 0) {
            setParametrosCarregados(true)
        }
    },[parametrosPorFilial])

    useEffect(()=> {
        if (!isMounted.current) return
        if (parametrosCarregados && orcamento.TipoOrcamento == 0 
                    && !descontoZerado
                    && valorParametroPorFilial("EXIGE_MOTIVO_DESCONTO_ORCAMENTO") == "S"
                )
        {
                
                obterMotivosDesconto() 
        }
    },[parametrosCarregados, descontoZerado])

    useEffect(() =>{
        if (!isMounted.current) return
 
        if (permissoes.length>=3)
            {
                
                if (permissoesMap.get("EXIBIR_CANAL_DE_VENDA") ) // 422642
                {
                    obterObterListaCanalDeVenda()
                }
            }
                
    },[permissoes])
    
    return (
        <Totalizador
            key={idUnico}
            orcamento={orcamento}
            numeroCasasDecimais={2}
            parametrosPorFilial={parametrosPorFilial} // 414608
            separarNacionalImportado={valorParametroPorFilial("PERMITE_DESDOBRAR_PEDIDO_PRODUTO_IMPORTADO") == "S"}
            exibirDescontoAcumuladoNacionalEImportado={valorParametro("DESCONTO_ACUMULADO") == "S"}
            exibirAcrescimoFinanceiro={valorParametro("ACRESCIMO_FINANCEIRO_VENDA_PRAZO") == "S"}
            exibirSubstituicao={true}
            aceitarProdutoSemEstoque={valorParametro("ACEITAR_PRODUTO_SEM_ESTOQUE") == "S"}
            exibirDadosDeQuantidadePendente={valorParametro("EXIBIR_QUANTIDADE_PENDENTE_ORCAMENTO") == "S"}
            exibirDescontoAcumulado={valorParametro("DESCONTO_ACUMULADO") == "S"}
            exibirMotivoDesconto={!descontoZerado &&orcamento.TipoOrcamento == 0 && valorParametroPorFilial("EXIGE_MOTIVO_DESCONTO_ORCAMENTO") == "S"}
            exibirPercentualDescontoAcumulado={(valorParametro("DESCONTO_ACUMULADO") == "S" && (valorParametro("EXIBIR_PERCENTUAL_DESCONTO_ACUMULADO_ORCAMENTO") == "S" || valorParametro("APLICAR_PERCENTUAL_DESCONTO_SOBRE_PRECO_UNITARIO") == "S"))}
            exibirValorIPI={ ( valorParametroPorFilial("APURA_IPI_VENDA_FILIAL") == "" && valorParametro("APURA_IPI_VENDA") == "S" ) || valorParametroPorFilial("APURA_IPI_VENDA_FILIAL") == "S"}
            exibirValorServicosAgregados={valorParametroPorFilial("UTILIZA_SERVICO_AGREGADO_ORCAMENTO") == "S" && valorParametroPorFilial("TEXTO_PADRAO_SERVICOS_ADICIONAIS_ORCAMENTO").length > 0}
            exibirCanalDeVenda={permissoesMap.get("EXIBIR_CANAL_DE_VENDA")} // 422642
            editarCanalDeVenda={permissoesMap.get("EXIBIR_CANAL_DE_VENDA") && permissoesMap.get("EDITAR_CANAL_DE_VENDA")} // 422642
            trabalhaComFretePercentualNoOrcamento={valorParametro("FRETE_PERCENTUAL_NO_ORCAMENTO") == "S"}
            
			desativarPercentualSeguro={totalizadorRedux.desabilitarEdicoes || orcamento.ItensOrcamento?.length <= 0 ? true : !permissoesMap.get("EDITAR_SEGURO")}
            desativarValorSeguro={totalizadorRedux.desabilitarEdicoes || orcamento.ItensOrcamento?.length <= 0 ? true : (!permissoesMap.get("EDITAR_SEGURO") || orcamento.PercentualSeguroEntrega > 0)}
            desativarValorFrete={totalizadorRedux.desabilitarEdicoes || orcamento.ItensOrcamento?.length <= 0}
            desativarAcrescimoFinanceiro={totalizadorRedux.desabilitarEdicoes || orcamento.ItensOrcamento?.length <= 0}
            desativarDespesasInclusas={!permissoesMap.get("EDITAR_DESPESAS_INCLUSAS") || (permissoesMap.get("EDITAR_DESPESAS_INCLUSAS") && (orcamentoSemItens || totalizadorRedux.desabilitarEdicoes))}
            desativarPercentualDesconto={desativacaoDesconto.percentualDesconto}
            desativarPercentualDescontoMercadoriasNacionais={desativacaoDesconto.percentualDescontoMercadoriasNacionais}
            desativarPercentualDescontoMercadoriasImportadas={desativacaoDesconto.percentualDescontoMercadoriasImportadas}
            desativarValorDesconto={desativacaoDesconto.valorDesconto}
            desativarValorDescontoMercadoriasNacionais={desativacaoDesconto.valorDescontoMercadoriasNacionais}
            desativarValorDescontoMercadoriasImportadas={desativacaoDesconto.valorDescontoMercadoriasImportadas}

            desativarPercentualDescontoAcumulado={desativacaoDesconto.percentualDescontoAcumulado}
            desativarPercentualDescontoAcumuladoMercadoriasNacionais={totalizadorRedux.desabilitarEdicoes || orcamentoSemItens || orcamento.ValorTotalMercadoriasNacionais <= 0}
            desativarPercentualDescontoAcumuladoMercadoriasImportadas={totalizadorRedux.desabilitarEdicoes || orcamentoSemItens || orcamento.ValorTotalMercadoriasImportadas <= 0}
            desativarValorDescontoAcumulado={orcamentoSemItens || totalizadorRedux.desabilitarEdicoes || valorParametro("APLICAR_PERCENTUAL_DESCONTO_SOBRE_PRECO_UNITARIO") == "S"}
            desativarValorDescontoAcumuladoMercadoriasNacionais={totalizadorRedux.desabilitarEdicoes || orcamentoSemItens || orcamento.ValorTotalMercadoriasNacionais <= 0 || valorParametro("APLICAR_PERCENTUAL_DESCONTO_SOBRE_PRECO_UNITARIO") == "S"}
            desativarValorDescontoAcumuladoMercadoriasImportadas={totalizadorRedux.desabilitarEdicoes || orcamentoSemItens || orcamento.ValorTotalMercadoriasImportadas <= 0 || valorParametro("APLICAR_PERCENTUAL_DESCONTO_SOBRE_PRECO_UNITARIO") == "S"}
            desativarValorIPI={totalizadorRedux.desabilitarEdicoes || orcamentoSemItens}
            desativarValorServicoAgregado={totalizadorRedux.desabilitarEdicoes || orcamento.ItensOrcamento?.length <= 0}

            desativarMotivoDesconto={orcamentoSemItens || totalizadorRedux.desabilitarEdicoes || descontoZerado}
            desativarCanalDeVenda={orcamentoSemItens || totalizadorRedux.desabilitarEdicoes} //422642
            onDespesasInclusasModificado={onDespesasInclusasModificado}
            onPercentualDescontoAcumuladoModificado={onPercentualDescontoAcumuladoModificado}
            onPercentualDescontoMercadoriasImportadasModifcado={onPercentualDescontoMercadoriasImportadasModifcado}
            onPercentualDescontoMercadoriasNacionaisModificado={onPercentualDescontoMercadoriasNacionaisModifcado}
            onPercentualSeguroModificado={onPercentualSeguroModificado}
            onValorDescontoAcumuladoModificado={onValorDescontoAcumuladoModificado}
            onValorDescontoMercadoriasImportadasModificado={onValorDescontoMercadoriasImportadasModifcado}
            onValorDescontoMercadoriasNacionaisModificado={onValorDescontoMercadoriasNacionaisModificado}
            onValorFreteModificado={onValorFreteModificado}
            onPercentualFreteModificado={onPercentualFreteModificado} // 445689
            onValorSeguroModificado={onValorSeguroModificado}
            onPercentualDescontoModificado={onPercentualDescontoModificado}
            onValorDescontoModificado={onValorDescontoModificado}
            onValorAcrescimoFinanceiroModificado={onValorAcrescimoFinanceiroModificado}
            motivosDesconto={motivosDesconto}
            onMotivoDescontoSelecionado={onMotivoDescontoSelecionado}
            listaCanalDeVenda={listaCanalDeVenda} // 422642
            onCanalDeVendaSelecionado={onCanalDeVendaSelecionado}  // 422642


            onValorDescontoAcumuladoNacionalModificado={onValorDescontoAcumuladoNacionalModificado}
            onPercentualDescontoAcumuladoNacionalModificado={onPercentualDescontoAcumuladoNacionalModificado}
            onPercentualDescontoAcumuladoImportadoModificado={onPercentualDescontoAcumuladoImportadoModifcado}
            onValorDescontoAcumuladoImportadoModificado={onValorDescontoAcumuladoImportadoModificado}
            onAplicarDescontoCashback={onAplicarDescontoCashback}
            onValorServicosAgregadosModificado={onValorServicosAgregadosModificado}
        />
    )
}

window.TotalizadorContainer = TotalizadorContainer
